export const ALL_OPTION = 'all';

export const initialState = {
  facility: ALL_OPTION,
  object: ALL_OPTION,
  machineId: ALL_OPTION,
  machineIds: []
};

export const parseParams = (defaultFilter) => {
  const parsedFilter = { ...defaultFilter };
  parsedFilter.facility = [null, ''].includes(parsedFilter.facility)
    ? ''
    : parsedFilter.facility || ALL_OPTION;
  parsedFilter.object = [null, ''].includes(parsedFilter.object)
    ? ''
    : parsedFilter.object || ALL_OPTION;
  parsedFilter.machineId = parsedFilter.machineId || ALL_OPTION;
  return parsedFilter;
};

export const filteredFacilityMachines = (machines, facilityValue) => {
  return filteredPropertyMachines(machines, facilityValue, 'facility');
};

export const filteredObjectMachines = (machines, objectValue) => {
  return filteredPropertyMachines(machines, objectValue, 'object');
};

const filteredPropertyMachines = (machines, propertyValue, property) => {
  let filteredMachines = [];
  if (!machines) {
    machines = [];
  }
  if (propertyValue === ALL_OPTION) {
    filteredMachines = machines;
  } else if (propertyValue) {
    filteredMachines = machines.filter(
      (machine) => machine[property] === propertyValue
    );
  } else {
    filteredMachines = machines.filter((machine) =>
      [null, ''].includes(machine[property])
    );
  }
  return filteredMachines;
};
